export default "__VITE_ASSET__B6jt_7YZ__"